import { h, render } from 'preact'
import App, { appId } from 'virtual:preact-app'

// `render`, not `hydrate`: both reuse the pre-rendered DOM nodes, but `hydrate` never updates the attributes rendered
// at build time, which differ whenever the browser resolves another language or number format than the pre-render.
const $container = document.getElementById(appId)

if ($container) render(<App />, $container)
